import "./index.css";
import React from "react";

interface TypeExpandedStateProps<T = boolean> {
  /**
   * @param expand 是否展开
   */
  expand: T;
  onClick(): void;
}

/**
 * @name ExpandedState 展开、收起状态管理
 * @description onClick
 */
const ExpandedState: React.FC<TypeExpandedStateProps> = ({
  expand,
  onClick,
}) => (
  <div onClick={() => onClick()} className="expanded-state">
    {expand ? (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.99935 4.94313V6.00033C3.99935 6.36852 3.70087 6.66699 3.33268 6.66699C2.96449 6.66699 2.66602 6.36852 2.66602 6.00033L2.66602 3.33366C2.66602 2.96547 2.96449 2.66699 3.33268 2.66699L5.99935 2.66699C6.36754 2.66699 6.66602 2.96547 6.66602 3.33366C6.66602 3.70185 6.36754 4.00033 5.99935 4.00033H4.94216L6.47075 5.52892C6.7311 5.78927 6.7311 6.21138 6.47075 6.47173C6.2104 6.73208 5.78829 6.73208 5.52794 6.47173L3.99935 4.94313ZM9.99935 4.00033C9.63116 4.00033 9.33268 3.70185 9.33268 3.33366C9.33268 2.96547 9.63116 2.66699 9.99935 2.66699H12.666C13.0342 2.66699 13.3327 2.96547 13.3327 3.33366V6.00033C13.3327 6.36852 13.0342 6.667 12.666 6.667C12.2978 6.667 11.9993 6.36852 11.9993 6.00033V4.94314L10.4708 6.47173C10.2104 6.73208 9.78829 6.73208 9.52794 6.47173C9.26759 6.21138 9.26759 5.78927 9.52794 5.52892L11.0565 4.00033H9.99935ZM3.33268 9.33366C3.70087 9.33366 3.99935 9.63213 3.99935 10.0003L3.99935 11.0575L5.52794 9.52892C5.78829 9.26857 6.2104 9.26857 6.47075 9.52892C6.7311 9.78927 6.7311 10.2114 6.47075 10.4717L4.94216 12.0003H5.99935C6.36754 12.0003 6.66602 12.2988 6.66602 12.667C6.66602 13.0352 6.36754 13.3337 5.99935 13.3337H3.33268C3.15587 13.3337 2.9863 13.2634 2.86128 13.1384C2.73625 13.0134 2.66602 12.8438 2.66602 12.667L2.66602 10.0003C2.66602 9.63213 2.96449 9.33366 3.33268 9.33366ZM9.52794 10.4717C9.26759 10.2114 9.26759 9.78927 9.52794 9.52892C9.78829 9.26857 10.2104 9.26857 10.4708 9.52892L11.9993 11.0575V10.0003C11.9993 9.63214 12.2978 9.33366 12.666 9.33366C13.0342 9.33366 13.3327 9.63214 13.3327 10.0003V12.667C13.3327 13.0352 13.0342 13.3337 12.666 13.3337H9.99935C9.63116 13.3337 9.33268 13.0352 9.33268 12.667C9.33268 12.2988 9.63116 12.0003 9.99935 12.0003H11.0565L9.52794 10.4717Z"
            fill="#6B6B6B"
          />
        </svg>
        Expand all
      </>
    ) : (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
        >
          <path
            d="M10.833 11.271V12.3282C10.833 12.6964 10.5345 12.9949 10.1663 12.9949C9.79815 12.9949 9.49967 12.6964 9.49967 12.3282V9.66153C9.49967 9.29334 9.79815 8.99486 10.1663 8.99486H12.833C13.2012 8.99486 13.4997 9.29334 13.4997 9.66153C13.4997 10.0297 13.2012 10.3282 12.833 10.3282H11.7758L13.3044 11.8568C13.5647 12.1171 13.5647 12.5393 13.3044 12.7996C13.044 13.0599 12.6219 13.0599 12.3616 12.7996L10.833 11.271Z"
            fill="#6B6B6B"
          />
          <path
            d="M10.1663 2.58008C10.5345 2.58008 10.833 2.87856 10.833 3.24674V4.30394L12.3616 2.77534C12.6219 2.51499 13.044 2.51499 13.3044 2.77534C13.5647 3.03569 13.5647 3.4578 13.3044 3.71815L11.7758 5.24675H12.833C13.2012 5.24675 13.4996 5.54522 13.4996 5.91341C13.4996 6.2816 13.2012 6.58008 12.833 6.58008H10.1663C9.98953 6.58008 9.81996 6.50984 9.69494 6.38482C9.56991 6.2598 9.49967 6.09023 9.49967 5.91341V3.24674C9.49967 2.87855 9.79815 2.58008 10.1663 2.58008Z"
            fill="#6B6B6B"
          />
          <path
            d="M3.66669 10.3282C3.2985 10.3282 3.00003 10.0297 3.00003 9.66153C3.00003 9.29334 3.2985 8.99486 3.66669 8.99486H6.33334C6.70153 8.99486 7 9.29334 7 9.66153V12.3282C7 12.6964 6.70153 12.9949 6.33334 12.9949C5.96515 12.9949 5.66668 12.6964 5.66668 12.3282V11.271L4.13809 12.7996C3.87775 13.0599 3.45564 13.0599 3.19529 12.7996C2.93494 12.5393 2.93494 12.1171 3.19529 11.8568L4.72387 10.3282H3.66669Z"
            fill="#6B6B6B"
          />
          <path
            d="M3.19529 3.71815C2.93494 3.4578 2.93494 3.03569 3.19529 2.77534C3.45564 2.51499 3.87774 2.51499 4.13809 2.77534L5.66668 4.30394V3.24675C5.66668 2.87856 5.96515 2.58008 6.33334 2.58008C6.70153 2.58008 7 2.87856 7 3.24675V5.91342C7 6.28161 6.70153 6.58008 6.33334 6.58008H3.66669C3.2985 6.58008 3.00002 6.28161 3.00002 5.91342C3.00002 5.54523 3.2985 5.24675 3.66669 5.24675H4.72387L3.19529 3.71815Z"
            fill="#6B6B6B"
          />
        </svg>
        Fold all
      </>
    )}
  </div>
);

export default ExpandedState;
